'use client';

import React from 'react';
import { Box, List, ListItem, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CustomImage from '@components/CustomImage';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import CommonContainer from '@components/CommonContainer';
import DynamicButton from '@components/DynamicButton';
import cn from './style.module.scss';

type ListItemType = {
  id?: number;
  itemsDescription: string;
};

type ListElementType = {
  listTitle: string;
  listItems: ListItemType[];
};

type ServiceItemType = {
  label: string;
  heading: string;
  descriptionOne: string[];
  listElement: ListElementType[];
  descriptionTwo: string[];
  src: string;
};

export default function WimbledonBridgeService(
  props: MarketingPageComponentProps
) {
  const serviceData: ServiceItemType[] =
    props?.locale?.section?.wimbledonBridgeServiceElements || [];

  return (
    <Stack component="section" className={cn.wimbledonBridgeService}>
      <Box className={cn.wimbledonServiceInner}>
        <Box className={cn.wimbledonServiceHeading}>
          <ParallaxText
            variant="h2"
            animationType="zoomIn"
            animationDuration={500}
          >
            {ReactHtmlParser(
              props?.locale?.section?.wimbledonBridgeServiceHeading
            )}
          </ParallaxText>
        </Box>
        <CommonContainer
          maxWidth={{ xs: '100%', md: '1360px', lg: '1360px' }}
          flexGrow={1}
        >
          <Box className={cn.wimbledonServiceBody}>
            <Box className={cn.wimbledonServiceContent}>
              {serviceData.map((item, index) => (
                <Box className={cn.wimbledonServiceBlock} key={index}>
                  <Box className={cn.wimbledonServiceText}>
                    <Box className={cn.wimbledonServiceText__heading}>
                      <ParallaxText
                        variant="p"
                        animationType="zoomIn"
                        animationDuration={500}
                      >
                        {ReactHtmlParser(item.label)}
                      </ParallaxText>{' '}
                      <ParallaxText
                        variant="h3"
                        animationType="zoomIn"
                        animationDuration={500}
                      >
                        {ReactHtmlParser(item.heading)}
                      </ParallaxText>
                    </Box>
                    <Box className={cn.wimbledonServiceText__description}>
                      {item.descriptionOne?.map((desc, i) => (
                        <ParallaxText
                          key={i}
                          variant="p"
                          animationType="zoomIn"
                          animationDuration={500}
                        >
                          {ReactHtmlParser(desc)}
                        </ParallaxText>
                      ))}
                      {item.listElement && item.listElement.length > 0 && (
                        <>
                          {item.listElement?.map((listBlock, i) => (
                            <Box className={cn.wimbledonListBlock} key={i}>
                              <ParallaxText
                                variant="p"
                                animationType="zoomIn"
                                animationDuration={500}
                              >
                                {ReactHtmlParser(listBlock.listTitle)}
                              </ParallaxText>

                              <List className={cn.wimbledonContentList}>
                                {listBlock.listItems?.map((listItem, j) => (
                                  <ListItem
                                    className={cn.wimbledonListItem}
                                    key={listItem.id || j}
                                  >
                                    {ReactHtmlParser(listItem.itemsDescription)}
                                  </ListItem>
                                ))}
                              </List>
                            </Box>
                          ))}
                        </>
                      )}

                      {item.descriptionTwo?.map((desc, i) => (
                        <ParallaxText
                          key={i}
                          variant="p"
                          animationType="zoomIn"
                          animationDuration={500}
                        >
                          {ReactHtmlParser(desc)}
                        </ParallaxText>
                      ))}
                    </Box>
                  </Box>
                  <Box className={cn.wimbledonContentStory}>
                    <CustomImage
                      src={item.src || ''}
                      alt="Wimbledon Feature Image"
                      width={768}
                      height={768}
                    />
                  </Box>
                </Box>
              ))}
            </Box>

            <Box className={cn.wimbledonServiceButton}>
              <DynamicButton
                className={cn.wimbledonServiceButton__element}
                children={props?.locale?.section?.wimbledonBridgeServiceButton}
                scrollToId="wimbledonBridgeRegistrationID"
              />
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
